import type {
  TenantModuleEntry,
  UpdateEnabledModulesRequest,
} from '../../api/modules.service';
import { route, type HandlerEntry } from '../handler-registry';

/**
 * Demo module catalog. The seeded demo club is a Karate club, so `karate` is the enabled
 * Primary module — this is what lights up the dashboard onboarding widget and karate-only
 * nav. Other club types are listed as available (disabled) Primaries.
 */
const DEMO_MODULES: readonly TenantModuleEntry[] = [
  {
    key: 'core',
    displayName: 'Core',
    kind: 'Core',
    version: '1.0.0',
    defaultDisciplines: [],
    dependsOn: [],
    authorizationTargets: [],
    featureFlags: [],
    xpTriggers: [],
    enabled: true,
  },
  {
    key: 'karate',
    displayName: 'Karate',
    kind: 'Primary',
    version: '1.0.0',
    defaultDisciplines: ['Karate'],
    dependsOn: [],
    authorizationTargets: [],
    featureFlags: [],
    xpTriggers: [],
    enabled: true,
  },
  {
    key: 'pt',
    displayName: 'Personal Training',
    kind: 'Primary',
    version: '1.0.0',
    defaultDisciplines: [],
    dependsOn: [],
    authorizationTargets: [],
    featureFlags: [],
    xpTriggers: [],
    enabled: false,
  },
  {
    key: 'nutrition',
    displayName: 'Nutriție',
    kind: 'Secondary',
    version: '1.0.0',
    defaultDisciplines: [],
    dependsOn: [],
    authorizationTargets: [],
    featureFlags: [],
    xpTriggers: [],
    enabled: false,
  },
];

export const modulesHandlers: readonly HandlerEntry[] = [
  route('GET', /^\/api\/tenants\/([^/]+)\/modules$/, () => DEMO_MODULES),
  route('GET', /^\/api\/_modules$/, () =>
    DEMO_MODULES.map(({ enabled, ...rest }) => rest),
  ),
  route('PUT', /^\/api\/tenants\/([^/]+)\/modules$/, (ctx) => {
    const body = ctx.body as UpdateEnabledModulesRequest;
    const keys = body?.enabledModuleKeys ?? [];
    return { tenantId: 'demo', enabledModuleKeys: keys };
  }),
];
